module.exports = __webpack_public_path__ + "media/flags/td-9c97dc0e.svg";